<div mat-dialog-title>
  Kopie van taak per e-mail versturen
  <button [mat-dialog-close]="false" class="mat-black" mat-flat-button>
    <mat-icon>close</mat-icon>
    Sluiten
  </button>
</div>
<div mat-dialog-content>
  <div fxLayout="column">
    <mat-form-field>
      <mat-label>
        <span>Selecteer uit het adressenboek</span>
      </mat-label>
      <mat-select [formControl]="form.controls.address_book_id">
        <mat-option [value]="null">Geen</mat-option>
        <mat-option *ngFor="let option of filters.addressBook.data" [value]="option.id">
          {{ option.name}} ({{ option.email }})
        </mat-option>
      </mat-select>
      <mat-spinner *ngIf="filters.addressBook.isLoading" diameter="20"></mat-spinner>
    </mat-form-field>
    <mat-form-field *ngFor="let input of form.controls.emails.controls; let i = index;">
      <mat-label>
        <span>E-mail</span>
      </mat-label>
      <input [formControl]="form.controls.emails.controls[i]" matInput placeholder="E-mail" type="email">
      <button (click)="removeEmail(i)" mat-icon-button matSuffix type="button">
        <mat-icon>delete</mat-icon>
      </button>
      <mat-error *ngIf="form.controls.emails.controls[i]?.errors?.required">
        Voer een geldig e-mail adres in
      </mat-error>
      <mat-error *ngIf="form.controls.emails.controls[i]?.errors?.email">
        Voer een geldig e-mailadres in
      </mat-error>
    </mat-form-field>
    <div class="fake-mat-form-field quill">
      <mat-label>Schrijf hier het bericht wat de ontvanger moet weten over deze taak</mat-label>
      <div class="fake-mat-form-field-content">
        <div class="quill-container">
          <quill-editor [formControl]="form.controls.note"
                        [modules]="quillService.basic.toolbar"
                        [formats]="quillService.basic.formats"
                        [styles]="{ flex: '1 1 auto' }"
                        (onContentChanged)="quillService.maxLength($event, 5000)"
                        [maxLength]="5000"
                        class="quill"
                        fxFlex="auto"
                        fxLayout="column"
                        placeholder="Schrijf hier het bericht wat de ontvanger moet weten over deze taak"></quill-editor>
        </div>
      </div>
      <mat-error *ngIf="formService.getFieldError('note')">
        {{ formService.getFieldError('note') }}
      </mat-error>
    </div>
  </div>
</div>
<mat-dialog-actions>
  <button (click)="addEmail()" class="mat-default" mat-flat-button type="button">
    E-mail ontvanger toevoegen
  </button>
  <button (click)="submit()" [disabled]="!form.valid" color="primary" mat-flat-button>VERSTUUR</button>
</mat-dialog-actions>
<fury-loading-overlay [isLoading]="isLoading" [fill]="true"></fury-loading-overlay>
